import { gql } from "@apollo/client";

export const CATEGORY_PRODUCT_COUNT_QUERY = gql`
  query productCount($categoryIds: [Identifier]) {
    product(category_ids: $categoryIds) {
      data {
        id
      }
      count
    }
  }
`;
